import { Alert, AlertTitle } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { InternalLinkButton } from '@omnea-app/fe-routing/InternalLinkButton'
import { isDefined } from '@omnea-app/packages/universal/type-guards/isDefined'

// Rendered on the integration page and on the dashboard, which passes href to link back here
export const NetsuiteMergeMigrationBanner = ({
  shouldShowBanner,
  integrationTitle,
  href,
}: {
  shouldShowBanner: boolean
  integrationTitle?: string
  href?: string
}) => {
  const { t } = useTranslation('integrations', {
    keyPrefix: 'accounting-settings.overview.merge-migration-banner',
  })

  if (!shouldShowBanner) return null

  return (
    <Alert
      severity="warning"
      action={
        isDefined(href) ? (
          <InternalLinkButton variant="text" color="secondary" size="small" href={href}>
            {t('action')}
          </InternalLinkButton>
        ) : undefined
      }
    >
      <AlertTitle>{t('title', { integration: integrationTitle })}</AlertTitle>
      {t('description', { integration: integrationTitle })}
    </Alert>
  )
}
